import { CATEGORIES } from '../data/categories';
import { useTodayEntry } from '../hooks/useTodayEntry';
import PromptCard from '../components/PromptCard';
import styles from './TodayScreen.module.css';

function formatDate(dateStr) {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('en-US', {
    weekday: 'long', month: 'long', day: 'numeric',
  });
}

export default function TodayScreen() {
  const {
    prompts, drafts, saving, submitted, submittedCategories,
    allFilled, updateDraft, saveDraft, submitCategory, submitEntry, reopenEntry,
  } = useTodayEntry();

  const today = new Date().toISOString().slice(0, 10);

  if (!prompts) {
    return <div className={styles.loading}>Loading prompts...</div>;
  }

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <p className={styles.date}>{formatDate(today)}</p>
        <h2 className={styles.heading}>Today's Prompts</h2>
      </header>

      <div className={styles.cards}>
        {CATEGORIES.map(cat => {
          const catLocked = submitted || submittedCategories.has(cat.key);
          const hasDraft = !!drafts[cat.key]?.trim();
          const indivSubmitted = submittedCategories.has(cat.key) && !submitted;

          return (
            <div key={cat.key} className={styles.cardWrapper}>
              <PromptCard
                category={cat}
                promptText={prompts[cat.key] || ''}
                value={drafts[cat.key]}
                onChange={val => updateDraft(cat.key, val)}
                onBlur={saveDraft}
                locked={catLocked}
              />
              {!catLocked && hasDraft && (
                <button
                  className={styles.catSubmitBtn}
                  style={{ '--accent': `var(${cat.accentVar})` }}
                  onClick={() => submitCategory(cat.key)}
                >
                  Post {cat.label}
                </button>
              )}
              {indivSubmitted && (
                <p className={styles.catPostedBadge}>✓ Posted to feed</p>
              )}
            </div>
          );
        })}
      </div>

      {submitted ? (
        <div className={styles.completedBar}>
          <span>Done for today 🎉</span>
          <button className={styles.editBtn} onClick={reopenEntry}>Edit</button>
        </div>
      ) : (
        <button
          className={`${styles.submitBtn} ${allFilled ? styles.ready : ''}`}
          onClick={submitEntry}
          disabled={!allFilled}
        >
          {allFilled ? "Submit all 4 entries" : `${CATEGORIES.filter(c => drafts[c.key]?.trim()).length} / 4 filled`}
        </button>
      )}
    </div>
  );
}
